export enum OnboardingTypeEnum {
  CONNECTORS_ENTRY = 'CONNECTORS_ENTRY',
}